export default function Section({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-5 w-xl border-black rounded-xl border-2 p-4 pt-3 override">
        {children}
    </div>
  );
};